import { SoQLType } from 'common/types/soql';

const WKT_LABELS: Partial<Record<SoQLType, string>> = {
  [SoQLType.SoQLMultiPointT]: 'MULTIPOINT',
  [SoQLType.SoQLLineT]: 'LINESTRING',
  [SoQLType.SoQLMultiLineT]: 'MULTILINESTRING',
  [SoQLType.SoQLPolygonT]: 'POLYGON',
  [SoQLType.SoQLMultiPolygonT]: 'MULTIPOLYGON',
};

/**
 * Returns the short text a table cell shows in place of a full geometry value, like `MULTIPOLYGON(...)`.
 * Points aren't shortened, so `point` and any non-geometry type return `null`.
 */
export function getTruncatedGeometry(soqlType: string | undefined): string | null {
  const label = WKT_LABELS[soqlType as SoQLType];

  if (!label) {
    return null;
  }

  return `${label}(...)`;
}
